import { Helmet } from 'react-helmet'
import StockChecker from './stockChecker'

const InventoryStockChecker = () => {
  return (
    <>
      <Helmet>
        <title>GAG Aggregator | Inventory Stock Checker</title>
      </Helmet>
      <div className="h-full">
        <StockChecker />
      </div>
    </>
  )
}

export default InventoryStockChecker
